import ChatPositionBlock from './ChatPositionBlock'

export default ChatPositionBlock
